import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation("components");
    return (
        <React.Fragment>
            <footer className="footer galaxy-border-none">
                <Container fluid>
                    <Row>
                        <Col sm={6}>
                            {new Date().getFullYear()} © FDS.
                        </Col>
                        <Col sm={6}>
                            <div className="text-sm-end d-none d-sm-block">
                                {t("footer.tasarimGelistirmeByDerenYazilim")}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;